import React from "react";
import { Button, Table, TableContainer, Tbody, Td, Th, Thead, Tr, VStack } from "@chakra-ui/react";
import { useQuery } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import templateApi from "../api/templateApi";
import ModulePageShell from "../components/common/ModulePageShell";
import OperationalPanel from "../components/common/OperationalPanel";
import PerformanceLocalNav from "../components/common/PerformanceLocalNav";
import StatusBadge from "../components/common/StatusBadge";
import { CompactEmptyState, PageSkeleton } from "../components/common/PageState";
import performanceQueryKeys from "../utils/queryKeys";
import { formatDateTime, personName, unwrapRows } from "../utils/normalize";

const PerformanceTemplateVersionsPage = () => {
  const { templateId } = useParams();
  const navigate = useNavigate();
  const versionsQuery = useQuery({
    queryKey: performanceQueryKeys.templates.versions(templateId),
    queryFn: () => templateApi.getPerformanceTemplateVersions(templateId),
    enabled: Boolean(templateId),
  });
  const rows = unwrapRows(versionsQuery.data);

  return (
    <ModulePageShell title="Template versions" description="Review published and draft versions of this PMS format." onRefresh={() => versionsQuery.refetch()}>
      <PerformanceLocalNav />
      <OperationalPanel>
        {versionsQuery.isLoading ? (
          <PageSkeleton rows={5} />
        ) : rows.length === 0 ? (
          <CompactEmptyState title="No versions found." />
        ) : (
          <VStack align="stretch" spacing={4}>
            <TableContainer>
              <Table size="sm">
                <Thead>
                  <Tr>
                    <Th>Version</Th>
                    <Th>Status</Th>
                    <Th>Created by</Th>
                    <Th>Created</Th>
                    <Th>Action</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {rows.map((item) => {
                    const version = item.version || item.versionNumber || item.number;
                    return (
                      <Tr key={item._id || item.id || version}>
                        <Td>{version}</Td>
                        <Td><StatusBadge value={item.status || "DRAFT"} /></Td>
                        <Td>{personName(item.createdBy)}</Td>
                        <Td>{formatDateTime(item.createdAt)}</Td>
                        <Td>
                          <Button size="xs" variant="outline" onClick={() => navigate(`/performance/pms-format/templates/${templateId}/versions/${version}`)}>
                            View
                          </Button>
                        </Td>
                      </Tr>
                    );
                  })}
                </Tbody>
              </Table>
            </TableContainer>
          </VStack>
        )}
      </OperationalPanel>
    </ModulePageShell>
  );
};

export default PerformanceTemplateVersionsPage;
